(function (module) {
    'use strict';

    /**
     * Shared controller for the full-page typed-credentials form and the
     * app-editor dialog adapter. Bindings/locals provide:
     *   - integrationTemplate : the selected IntegrationTemplate object
     *   - onSuccess           : callback(integration) called after save
     *
     * Renders one formly field per template.credentialFields entry.
     * For the 'workday' provider, applies URL + tenant cross-validation.
     *
     * Tests the upstream provider connection through SLS, then saves encrypted
     * credentials through rocket-api only when the provider accepts them.
     */
    function TypedCredentialsCtrl(
        $mdDialog,
        $http,
        workdayUrlValidator,
        envService,
        typedCredentialFields,
        typedCredentialsConnection
    ) {
        this.model = {};
        this.errors = {};
        this.saving = false;

        var self = this;

        var API_BASE = '//localhost:3000';
        var SLS_BASE = '//localhost:7000';
        try {
            API_BASE = envService.read('API_URI') || API_BASE;
            SLS_BASE = envService.read('SLS_URI') || SLS_BASE;
        } catch (e) { /* guard: envService may throw in some environments */ }

        /**
         * Build formly fields array from template.credentialFields.
         * credentialFields can be legacy key strings or API metadata objects.
         */
        this.$onInit = function () {
            var fields = (self.integrationTemplate && self.integrationTemplate.credentialFields) || [];
            self.fields = typedCredentialFields.buildTypedCredentialFields(fields);
            self.credentialGuidance = typedCredentialFields.typedCredentialGuidance(
                self.integrationTemplate && self.integrationTemplate.provider
            );
        };

        this.cancel = function () {
            if (self.presentation === 'page' && self.onCancel) {
                self.onCancel();
                return;
            }
            $mdDialog.hide();
        };

        /**
         * Client-side validation before submit.
         * Returns true if valid; false if invalid (populates this.errors).
         */
        this.validate = function (credentials) {
            self.errors = {};
            var provider = self.integrationTemplate && self.integrationTemplate.provider;
            credentials = credentials || typedCredentialFields.buildProviderCredentials(provider, self.model);

            if (provider === 'workday') {
                var usesSourceFields = (self.fields || []).some(function (field) {
                    return field.key === 'hostname' || field.key === 'tenant';
                });
                if (usesSourceFields) {
                    var sourceError = workdayUrlValidator.validateWorkdaySourceFields(
                        self.model.hostname, self.model.tenant
                    );
                    if (sourceError) {
                        self.errors.workdayUrl = sourceError;
                        return false;
                    }
                }

                var urlError = workdayUrlValidator.validateWorkdayUrl(credentials.workdayUrl);
                if (urlError) {
                    self.errors.workdayUrl = urlError;
                    return false;
                }

                var tenantError = workdayUrlValidator.validateWorkdayTenantMatch(
                    credentials.workdayUrl, credentials.username
                );
                if (tenantError) {
                    self.errors.username = tenantError;
                    return false;
                }
            }

            return true;
        };

        this.submit = function () {
            var provider = self.integrationTemplate && self.integrationTemplate.provider;
            var credentials = typedCredentialFields.buildProviderCredentials(provider, self.model);
            if (!self.validate(credentials)) return;

            self.saving = true;
            typedCredentialsConnection.connect({
                $http: $http,
                slsBaseUrl: SLS_BASE,
                apiBaseUrl: API_BASE,
                integrationTemplate: self.integrationTemplate,
                credentials: credentials,
            })
                .then(function (integration) {
                    self.saving = false;
                    if (self.presentation !== 'page') {
                        $mdDialog.hide(integration);
                    }
                    if (self.onSuccess) {
                        self.onSuccess(integration);
                    }
                })
                .catch(function (error) {
                    self.saving = false;
                    self.errors.submit = typedCredentialsConnection.errorMessage(error);
                });
        };
    }

    module
        .controller('TypedCredentialsDialogCtrl', TypedCredentialsCtrl)
        .component('typedCredentialsForm', {
            bindings: {
                integrationTemplate: '<',
                onCancel: '<',
                onSuccess: '<',
                presentation: '@',
            },
            controller: TypedCredentialsCtrl,
            templateUrl: '/js/integrations/typed-credentials/typed-credentials-form.html',
        });

})(angular.module('rocket.components'));
